import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "../lib/consent";
import { Switch } from "./ui/switch";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(false);
  const [c, setC] = useState({ analytics: true, marketing: false });

  useEffect(() => {
    const reopen = () => {
      setCustom(true);
      setOpen(true);
    };
    window.addEventListener("mhm-open-consent", reopen);
    const t = getConsent() ? null : setTimeout(() => setOpen(true), 1800);
    return () => {
      if (t) clearTimeout(t);
      window.removeEventListener("mhm-open-consent", reopen);
    };
  }, []);

  const save = (v) => {
    setConsent(v);
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          className="fixed inset-x-3 bottom-3 z-[90] mx-auto max-w-2xl rounded-2xl border border-white/10 bg-navy p-5 text-white shadow-2xl sm:bottom-5 sm:p-6"
        >
          <div className="flex gap-3">
            <Cookie className="mt-0.5 h-6 w-6 shrink-0 text-brand" />
            <div className="text-sm text-slate-300">
              <p className="font-semibold text-white">We value your privacy</p>
              <p className="mt-1">We use cookies to understand how visitors use our website (analytics) and, only with your permission, to show you relevant MHM SUPER ADBLUE ads (marketing). We never collect your contact details unless you submit a form. <Link to="/privacy-policy" className="text-brand underline">Privacy policy</Link></p>
            </div>
          </div>
          {custom && (
            <div className="mt-4 space-y-3 rounded-xl bg-white/5 p-4 text-sm">
              <label className="flex items-center justify-between gap-3"><span>Essential (always on)</span><Switch checked disabled /></label>
              <label className="flex items-center justify-between gap-3"><span>Analytics — visits, pages, device, approximate city</span><Switch data-testid="consent-analytics-toggle" checked={c.analytics} onCheckedChange={(v) => setC({ ...c, analytics: v })} /></label>
              <label className="flex items-center justify-between gap-3"><span>Marketing — Google &amp; Meta ads remarketing</span><Switch data-testid="consent-marketing-toggle" checked={c.marketing} onCheckedChange={(v) => setC({ ...c, marketing: v })} /></label>
            </div>
          )}
          <div className="mt-4 flex flex-wrap justify-end gap-2">
            {custom ? (
              <button data-testid="consent-save-button" onClick={() => save(c)} className="rounded-full bg-brand px-5 py-2.5 text-sm font-semibold">Save choices</button>
            ) : (
              <button data-testid="consent-customize-button" onClick={() => setCustom(true)} className="rounded-full px-4 py-2.5 text-sm font-semibold text-slate-300 hover:text-white">Customise</button>
            )}
            <button data-testid="consent-reject-button" onClick={() => save({ analytics: false, marketing: false })} className="rounded-full border border-white/20 px-5 py-2.5 text-sm font-semibold hover:border-white">Essential only</button>
            <button data-testid="consent-accept-button" onClick={() => save({ analytics: true, marketing: true })} className="rounded-full bg-brand px-5 py-2.5 text-sm font-semibold hover:bg-brand-dark">Accept all</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
